import React, { useEffect, useState } from "react";
import { useTonConnectUI } from "@tonconnect/ui-react";

import SmallLogo from "../assets/logo/small-logo.svg";
import MoneyIcon from "../assets/icons/money-icon.svg";
import RefGroupIcon from "../assets/icons/refs-group-icon.svg";
import TicketIcon from "../assets/icons/ticket-pink-icon.svg";
import PriseIcon from "../assets/icons/prise-icon.svg";
import { PlayerBasicInfoDTO } from "../blockchain/lotteryClient";
import { getPlayerBasicInfo } from "../blockchain/lotteryClient";
import { useTonWallet } from "@tonconnect/ui-react";


function Quests() {

    const [player, setPlayer] = useState<PlayerBasicInfoDTO | null>(null);
    const [loading, setLoading] = useState(false);
    const wallet = useTonWallet();
    const address = wallet?.account.address;


    useEffect(() => {
        if (!address) {
            setPlayer(null);
            return;
        }

        let cancelled = false;

        (async () => {
            setLoading(true);
            try {
                const info = await getPlayerBasicInfo(address);
                if (!cancelled) setPlayer(info);
            } finally {
                if (!cancelled) setLoading(false);
            }
        })();

        return () => {
            cancelled = true;
        };
    }, [address]);

    // ===== QUEST DATA =====
    const referrals = player?.referredCount ?? 0;
    const soldTickets = player?.ticketsSoldByReferrals ?? 0;
    const winStreakDone = (player?.inRowBonus ?? 0n) > 0n;

    const referralEarned = Number(player?.referralBonus ?? 0n) / 1e9;
    const soldEarned = Number(player?.soldBonus ?? 0n) / 1e9;
    const streakEarned = Number(player?.inRowBonus ?? 0n) / 1e9;


    if (loading) {
        return <div className="quests">Загрузка...</div>;
    }

    return (
        <div className="quests">
            <div className="quests_image">
                <img src={SmallLogo} alt="logo" width="129" height="73" />
            </div>

            <span className="quests_title">Задания</span>

            <div className="cards-group">

                {/* 🔹 REFERRALS */}
                <div className="quests_card">
                    <div className="quests_card__header">
                        <div className="quests_card__header___left">
                            <img src={RefGroupIcon} alt="icon" width={64} height={64} />
                            <div className="quests_card__header___left____task">
                                <div className="quests_card__header___left____task_____title">
                                    Привлечь 10 <br /> рефералов
                                </div>
                                <div className="quests_card__header___left____task_____count">
                                    {referrals}/10
                                </div>
                            </div>
                        </div>
                        <div className="quests_card__header___right">
                            <img src={MoneyIcon} alt="icon" width={45} height={45} />
                            <span>5 USDT</span>
                        </div>
                    </div>
                    <div className="quests_card__bottom">
                        <span className="quests_card__bottom___text">
                            Заработано: {referralEarned.toFixed(2)} USDT
                        </span>
                    </div>
                </div>

                {/* 🔹 SOLD TICKETS */}
                <div className="quests_card">
                    <div className="quests_card__header">
                        <div className="quests_card__header___left">
                            <img src={TicketIcon} alt="icon" width={64} height={64} />
                            <div className="quests_card__header___left____task">
                                <div className="quests_card__header___left____task_____title">
                                    Продать 50 <br /> билетов
                                </div>
                                <div className="quests_card__header___left____task_____count">
                                    {soldTickets}/50
                                </div>
                            </div>
                        </div>
                        <div className="quests_card__header___right">
                            <img src={MoneyIcon} alt="icon" width={45} height={45} />
                            <span>20 USDT</span>
                        </div>
                    </div>
                    <div className="quests_card__bottom">
                        <span className="quests_card__bottom___text">
                            Заработано: {soldEarned.toFixed(2)} USDT
                        </span>
                    </div>
                </div>

                {/* 🔹 3 WINS IN A ROW */}
                <div className="quests_card">
                    <div className="quests_card__header">
                        <div className="quests_card__header___left">
                            <img src={PriseIcon} alt="icon" width={64} height={64} />
                            <div className="quests_card__header___left____task">
                                <div className="quests_card__header___left____task_____title">
                                    Победить 3 <br /> раза подряд
                                </div>
                                <div className="quests_card__header___left____task_____count">
                                    {winStreakDone ? 3 : 0}/3
                                </div>
                            </div>
                        </div>
                        <div className="quests_card__header___right">
                            <img src={MoneyIcon} alt="icon" width={45} height={45} />
                            <span>5 USDT</span>
                        </div>
                    </div>
                    <div className="quests_card__bottom">
                        <span className="quests_card__bottom___text">
                            Заработано: {streakEarned.toFixed(2)} USDT
                        </span>
                    </div>
                </div>

            </div>
        </div>
    );
}

export default Quests;
